var api = require("!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../node_modules/mini-css-extract-plugin/dist/loader.js!../../../node_modules/cache-loader/dist/cjs.js!../../../node_modules/css-loader/dist/cjs.js??ref--9-3!../../../node_modules/postcss-loader/src/index.js??ref--9-4!../../../node_modules/resolve-url-loader/index.js??ref--9-5!../../../node_modules/sass-loader/dist/cjs.js??ref--9-6!../../../node_modules/import-glob/index.js!./main.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;